<template>
  <v-card class="ma-3 pa-5">
    <h4>Create new culture</h4>
    <v-row class="px-3 ga-3">
      <v-text-field v-model="newCulture.code" type="text" label="Index"/>
      <v-text-field v-model="newCulture.la_culture" type="text" label="LA"/>
      <v-text-field v-model="newCulture.et_culture" type="text" label="ET"/>
      <v-text-field v-model="newCulture.en_culture" type="text" label="EN"/>
      <v-text-field v-model="newCulture.fi_culture" type="text" label="FI"/>
      <v-text-field v-model="newCulture.lt_culture" type="text" label="LT"/>
      <v-select v-model="newCulture.growth_phase_id" item-value="id"
            item-text="name" :items="cultureTypes" label="Growth Phase Type"/>
      <v-select v-model="newCulture.culture_type"
            :items="availableCultureTypes" label="Culture Type"/>
      <v-text-field v-model.number="newCulture.level_0_growth_phase"
            type="number" label="Level 0 Growth Phase"/>
      <v-btn class="ma-4" @click="createNewCulture" small color="primary">Save</v-btn>
    </v-row>
  </v-card>
</template>
<script>

import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: "CreateCultureCard",
  data() {
    return {}
  },
  computed: {
    ...mapState('culture', ['newCulture', 'cultureTypes', 'cultures', 'availableCultureTypes']),
    ...mapGetters('culture', ['getNextCultureIndex'])
  },
  methods: {
    ...mapActions('culture', ['handleNewCultureClick']),
    ...mapActions('culture', ['fetchCulture']),
    ...mapMutations('culture', ['setNewCultureIndex']),
    async createNewCulture() {
      if (!this.newCulture.code) {
        return alert('Please fill Index field!')
      }
      await this.handleNewCultureClick()
    }
  },
  watch: {
    newCulture: async function () {
      if (Object.keys(this.newCulture).length === 0) await this.fetchCulture()

    },
    cultures: function () {
      const nextCultureIndex = this.getNextCultureIndex
      this.setNewCultureIndex({code: nextCultureIndex})
    }
  }
}
</script>

<style scoped>
.ga-3 {
  column-gap: 12px !important;
}
</style>